import { create } from 'zustand';

interface IInvoicesState {
  logisticServiceId?: number;
  orderId?: number;
  storageInvoiceId?: number;
  organizationName?: string;
  paymentAgreementDate?: string;
  paymentAgreementDays?: number;
  hasActiveCredit?: boolean;
  isPaymentAgreement?: boolean;
  invoiceType?: 'order' | 'logistic-service';
  setLogisticServiceId: (logisticServiceId: number) => void;
  setOrderId: (orderId: number) => void;
  setStorageInvoiceId: (storageInvoiceId: number) => void;
  setOrganizationName: (organizationName: string) => void;
  setPaymentAgreementDate: (paymentAgreementDate: string) => void;
  setPaymentAgreementDays: (paymentAgreementDays: number) => void;
  setHasActiveCredit: (hasActiveCredit: boolean) => void;
  setIsPaymentAgreement: (isPaymentAgreement: boolean) => void;
  setInvoiceType: (invoiceType: 'order' | 'logistic-service') => void;
}

const useInvoicesState = create<IInvoicesState>(set => ({
  logisticServiceId: undefined,
  orderId: undefined,
  organizationName: undefined,
  paymentAgreementDate: undefined,
  paymentAgreementDays: undefined,
  hasActiveCredit: undefined,
  isPaymentAgreement: undefined,
  invoiceType: undefined,
  setLogisticServiceId: logisticServiceId => set({ logisticServiceId }),
  setOrderId: orderId => set({ orderId }),
  setOrganizationName: organizationName => set({ organizationName }),
  setPaymentAgreementDate: paymentAgreementDate => set({ paymentAgreementDate }),
  setPaymentAgreementDays: paymentAgreementDays => set({ paymentAgreementDays }),
  setHasActiveCredit: hasActiveCredit => set({ hasActiveCredit }),
  setIsPaymentAgreement: isPaymentAgreement => set({ isPaymentAgreement }),
  setInvoiceType: invoiceType => set({ invoiceType }),
  setStorageInvoiceId: storageInvoiceId => set({ storageInvoiceId })
}));

export default useInvoicesState;
